//@flow
import React from 'react';

type Props = {
  imageUrl:string,
  alt:string,
};

export default function ProductImage(props:Props) {
  return (
    <img
      className="product-image"
      src={props.imageUrl}
      alt={props.alt || ''}
    />
  );
}
